import { FunctionComponent, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { afterPendingPasswordChange } from "@/pages/Private/redux/account/account.api";
import { tokenAdoptionDecision } from "@/utils/auth/tokenAdoption";

import { useAppDispatch } from "@/redux/hooks";
import { ROUTE_CONFIG } from "@/routes/config";
import { LoadingOverlay } from "@/components";

import { resetAuth, setAuth } from "../Public/redux/auth.slice";

const { LOGIN } = ROUTE_CONFIG;

export const Logout: FunctionComponent = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const handledRef = useRef(false);

	useEffect(() => {
		if (handledRef.current) {
			return;
		}

		handledRef.current = true;
		const rejectedToken = sessionStorage.getItem("rejectedAuthToken");

		afterPendingPasswordChange(() => {
			const storedToken = localStorage.getItem("token");
			const decision = tokenAdoptionDecision(rejectedToken, storedToken);

			sessionStorage.removeItem("rejectedAuthToken");

			if (decision === "adopt") {
				dispatch(setAuth({ token: storedToken }));
				navigate("/", { replace: true });

				return;
			}

			if (decision === "reload") {
				// Reloading /logout itself would clear the replacement credential on the next mount.
				window.location.replace("/");

				return;
			}

			dispatch(resetAuth());
			navigate(LOGIN, { replace: true });
		});
	}, [dispatch, navigate]);

	return <LoadingOverlay />;
};
